import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {EventsManagerService} from './events-manager.service';
import {AppConfigManagerService} from './app-config-manager.service';
import {AuthApiService} from '../Api/Auth/auth-api.service';

@Injectable({
  providedIn: 'root'
})
export class MultisessionManagerService {

  private intervalTime: any;
  private timeMultisession: number = 0;

  private modalMultisession: HTMLIonModalElement | null = null;

  constructor(
    protected auth: AuthApiService,
    protected modalCtrl: ModalController,
    protected eventsManager: EventsManagerService,
    protected appConfigManager: AppConfigManagerService,
  ) {
  }


  /**
   * Seleccionar usuario
   *
   */
  public async selectUserMultisession() {
    const {MultisessionListPage} = await import('../../Pages/Multisession/multisession-list/multisession-list.page');

    if (!this.appConfigManager.appConfig?.multisession?.active || this.modalMultisession) {
      return;
    }

    this.saveForceModal(true);

    this.modalMultisession = await this.modalCtrl.create({
      component: MultisessionListPage,
      backdropDismiss: false,
      cssClass: 'yu-modal',
    });

    this.modalMultisession.onDidDismiss().then((data) => {

      if (data.data) {
        this.multisessionTime();
        this.saveForceModal(false);

        this.eventsManager.publish({name: 'refresh:user'});
        this.eventsManager.publish({name: 'refresh:session'});
      }

      this.modalMultisession = null;
    });

    await this.modalMultisession.present();
  }


  /**
   * Resetear configuración de la multisesión
   *
   */
  public resetMultisessionConfig() {

    if (!this.appConfigManager?.appConfig?.multisession) {
      return;
    }

    this.appConfigManager.appConfig.multisession = {
      active: false,
      locked_automatic: false,
      locked_logout: false,
      force_modal: false,
    };

    this.appConfigManager.saveAppConfig();
  }


  /**
   * Tiempo multisesión
   *
   */
  public multisessionTime() {
    const date: Date = new Date();
    this.timeMultisession = date.getTime() + 120000; // 2 minutes
  }


  /**
   * Comprobar tiempo multisesión
   *
   */
  public checkMultisessionTime() {

    this.multisessionTime();
    this.destroyInterval();

    this.intervalTime = setInterval(() => {
      const now: Date = new Date();
      const isInactive: boolean = this.timeMultisession < now.getTime() && this.appConfigManager.appConfig?.multisession?.locked_automatic;

      if (this.auth.userIsLogIn() && (isInactive || this.appConfigManager.appConfig?.multisession?.force_modal)) {
        this.selectUserMultisession();
      }
    }, 5000);
  }


  /**
   * Destruir intervalo
   *
   */
  private destroyInterval() {
    clearInterval(this.intervalTime);
    this.intervalTime = null;
  }


  /**
   * Guardar si se debe abrir el modal
   *
   */
  saveForceModal(force: boolean) {
    this.appConfigManager.appConfig.multisession.force_modal = force;
    this.appConfigManager.saveAppConfig();
  }

}
